module.exports = __webpack_public_path__ + "img/education.9167ffb4.svg";